import { render, staticRenderFns } from "./educationCurriculumnPop.vue?vue&type=template&id=a7b71f44"
import script from "./educationCurriculumnPop.vue?vue&type=script&lang=js"
export * from "./educationCurriculumnPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7b71f44')) {
      api.createRecord('a7b71f44', component.options)
    } else {
      api.reload('a7b71f44', component.options)
    }
    module.hot.accept("./educationCurriculumnPop.vue?vue&type=template&id=a7b71f44", function () {
      api.rerender('a7b71f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/educationCurriculumnPop.vue"
export default component.exports